var audio_rtlignore_default = {
  "fontElementMap": "yqCgN",
  "container": "nnRS2",
  "customPlayer": "wg6CX",
  "slim": "sGhx4",
  "playPauseButton": "nyZjx",
  "coverImage": "_2s7p5",
  "trackDetailsContainer": "_3TxcL",
  "controlsContainer": "EmWhA",
  "controlsGroup": "eXQCa",
  "sliderContainer": "oolZ7",
  "audioDuration": "PZks8",
  "isLoading": "sukin",
  "audioDetails": "M9vHD",
  "authorName": "ZGdtJ",
  "title": "rEqJ0",
  "dropdownMenuWrapper": "vxtiy",
  "dropdownSelectedButton": "RGWbs",
  "dropdownContent": "jUNP9",
  "dropdownContentWithIcon": "enzeD",
  "audioLoader": "JeJzg"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
